import { subMonths } from 'date-fns';

const MONTH_LABELS = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

const CURRENT_YEAR = new Date().getFullYear();
const YEAR_OPTIONS = Array.from({ length: 22 }, (_, index) => CURRENT_YEAR + 1 - index);

const getYearOptions = (headerYear) => (
    YEAR_OPTIONS.includes(headerYear)
        ? YEAR_OPTIONS
        : [...YEAR_OPTIONS, headerYear].sort((a, b) => b - a)
);

// Headless UI's Menu intercepts Enter/Space/typeahead keys, which breaks native <select> keyboard use.
const stopMenuKeyHandling = (event) => {
    if (event.key !== 'Escape') event.stopPropagation();
};

export const createRangeCalendarHeader = (monthsShown) => function RangeCalendarHeader({
    monthDate,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
    customHeaderCount = 0,
}) {
    const showPrevNav = customHeaderCount === 0;
    const showNextNav = customHeaderCount === monthsShown - 1;
    const headerYear = monthDate.getFullYear();

    // react-datepicker navigates relative to the first visible month, so later headers subtract their offset.
    const goTo = (year, month) => {
        const firstMonth = subMonths(new Date(year, month, 1), customHeaderCount);
        changeYear(firstMonth.getFullYear());
        changeMonth(firstMonth.getMonth());
    };

    return (
        <div className="cfamex-calendar-header" onKeyDown={stopMenuKeyHandling}>
            {showPrevNav ? (
                <button
                    onClick={decreaseMonth}
                    disabled={prevMonthButtonDisabled}
                    type="button"
                    aria-label="Mes anterior"
                    className="cfamex-calendar-header__nav"
                >
                    <svg className="cfamex-calendar-header__nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                </button>
            ) : (
                <span className="cfamex-calendar-header__nav cfamex-calendar-header__nav--spacer" aria-hidden="true" />
            )}

            <div className="cfamex-calendar-header__selects">
                <select
                    value={monthDate.getMonth()}
                    onChange={({ target: { value } }) => goTo(headerYear, parseInt(value, 10))}
                    aria-label="Mes"
                    className="cfamex-calendar-header__select"
                >
                    {MONTH_LABELS.map((month, index) => (
                        <option key={month} value={index}>
                            {month}
                        </option>
                    ))}
                </select>

                <select
                    value={headerYear}
                    onChange={({ target: { value } }) => goTo(parseInt(value, 10), monthDate.getMonth())}
                    aria-label="Año"
                    className="cfamex-calendar-header__select cfamex-calendar-header__select--year"
                >
                    {getYearOptions(headerYear).map((year) => (
                        <option key={year} value={year}>
                            {year}
                        </option>
                    ))}
                </select>
            </div>

            {showNextNav ? (
                <button
                    onClick={increaseMonth}
                    disabled={nextMonthButtonDisabled}
                    type="button"
                    aria-label="Mes siguiente"
                    className="cfamex-calendar-header__nav"
                >
                    <svg className="cfamex-calendar-header__nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                </button>
            ) : (
                <span className="cfamex-calendar-header__nav cfamex-calendar-header__nav--spacer" aria-hidden="true" />
            )}
        </div>
    );
};
